<template>
    <v-container grid-list-md class="form-user-profile">
        <v-layout row wrap>
            <v-flex md8>
                <v-form ref="form_user_profile">
                    <v-layout align-center row class="pa-0" style="min-height: 48px;">
                        <v-flex md4>
                            <label class="text-color">Tên Tài Khoản</label>
                        </v-flex>
                        <v-flex md8>
                            <v-label><b>{{ username }}</b></v-label>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Email</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    type="text"
                                    v-model="email"
                                    required
                                    :rules="emailRules"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="pa-0">
                            <v-flex md4>
                                <label class="text-color">Họ và Tên</label>
                            </v-flex>
                            <v-flex md8>
                                <v-text-field
                                        solo
                                        type="text"
                                        v-model="name"
                                        :counter="50"
                                        required
                                        :rules="nameRules"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                    <v-layout align-center row class="pa-0">
                            <v-flex md4>
                                <label class="text-color">Số Điện Thoại</label>
                            </v-flex>
                            <v-flex md8>
                                <v-text-field
                                        v-model="mobile"
                                        solo
                                        required
                                        type="text"
                                        :rules="mobileRules"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Nhập Link Facebook của bạn</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="facebook_account"
                                    placeholder="Nhập vào fb id của bạn"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Mật khẩu cũ</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="old_password"
                                    type="password"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Mật khẩu mới</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="new_password"
                                    type="password"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Nhập lại mật khẩu mới</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="new_password_confirmation"
                                    :rules="newConfirmPasswordRules"
                                    type="password"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                </v-form>


                <v-layout align-center row>
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text" @click="saveProcess">
                            Lưu thông tin
                        </v-btn>
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex md4>
                <UserProfileAvatar />
            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                    indeterminate
                    color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
    import UserProfileAvatar from "~/components/user-profile/UserProfileAvatar";
    import { COLOR } from "~/config/constant";
    // import Swal from 'sweetalert2';
    import {AUTH_UPDATE, AUTH_USER} from "~/store/actions.type";
    // import {getParamsFromUrl, } from "../../common/helper.string";

    export default {
        name: "FbPostCreateProcess",
        components: {
            UserProfileAvatar
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                COLOR: COLOR,

                // Ten tai khoan
                username: '',
                // Email
                email: '',
                //FullName
                name:'',
                //So dien thoai
                mobile: '',
                // Facebook id
                facebook_account: '',
                //Mat khau hien tai
                old_password: '',
                //New password
                new_password: '',
                //Confirm password
                new_password_confirmation: '',

                nameRules: [
                    v => !!v || 'Vui lòng nhập Họ Tên',
                    v => (v && v.length <= 191) || 'Họ Tên không được quá 191 ký tự',
                ],
                emailRules: [
                    v => !!v || 'Vui lòng nhập Email',
                    v => /.+@.+\..+/.test(v) || 'Email không hợp lệ',
                ],
                mobileRules: [
                    v => !!v || 'Vui lòng nhập số điện thoại liên hệ',
                    v => /(09|01|03|[2|6|8|9])+([0-9]{8})\b/.test(v) || 'Số điện thoại không hợp lệ !',
                ],
                newConfirmPasswordRules: [
                    v => (v === this.new_password) || 'Password không khớp'
                ],



            }
        },

        created() {

        },

        computed: {

        },
        mounted() {
            this.initDefault();
        },
        watch: {
            // facebook_account(){
            //     if (isNaN(this.facebook_account)) {
            //         this.facebook_account = getParamsFromUrl(this.facebook_account,'id');
            //     }
            // },
        },
        methods: {

            async initDefault() {
                let result = await this.$store.dispatch(AUTH_USER);
                let currentUser = result.data;

                this.username           = currentUser.username !== null ? currentUser.username : '';
                this.name               = currentUser.name !== null ? currentUser.name : '';
                this.email              = currentUser.email !== null ? currentUser.email : '';
                this.mobile             = currentUser.customer.mobile !== null ? currentUser.customer.mobile : '';
                this.facebook_account =
                    currentUser.customer.account !== null &&
                    currentUser.customer.account.link_profile !== null
                        ? currentUser.customer.account.link_profile
                        : '';
            },
             saveProcess() {
                let params = this.getParams();

                if (this.$refs.form_user_profile.validate()) {
                    this.overlay = true;

                    this.$store.dispatch(AUTH_UPDATE, params).then((res) => {
                        if (res !== false) {
                            window.$(".st-username").html(this.username);
                        }
                        this.overlay = false;
                        this.initDefault();
                    });
                }
            },
            getParams() {
              if (!this.old_password && !this.new_password && !this.new_password_confirmation) {
                  if (!this.facebook_account) {
                      return {
                          // Ten tai khoan
                          username: this.username,
                          // Email
                          email: this.email,
                          //FullName
                          name: this.name,
                          //So dien thoai
                          mobile: this.mobile,
                      };
                  } else {
                      return {
                          // Ten tai khoan
                          username: this.username,
                          // Email
                          email: this.email,
                          //FullName
                          name: this.name,
                          //So dien thoai
                          mobile: this.mobile,
                          // Facebook id
                          facebook_account: this.facebook_account,
                      };
                  }

              } else {
                  if (!this.facebook_account) {
                      return {
                          // Ten tai khoan
                          username: this.username,
                          // Email
                          email: this.email,
                          //FullName
                          name: this.name,
                          //So dien thoai
                          mobile: this.mobile,
                          //Mat khau hien tai
                          old_password: this.old_password,
                          //New password
                          new_password: this.new_password,
                          //Confirm password
                          new_password_confirmation: this.new_password_confirmation,
                      };
                  } else {
                      return {
                          // Ten tai khoan
                          username: this.username,
                          // Email
                          email: this.email,
                          //FullName
                          name: this.name,
                          //So dien thoai
                          mobile: this.mobile,
                          // Facebook id
                          facebook_account: this.facebook_account,
                          //Mat khau hien tai
                          old_password: this.old_password,
                          //New password
                          new_password: this.new_password,
                          //Confirm password
                          new_password_confirmation: this.new_password_confirmation,
                      };
                  }

              }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .form-user-profile {
        background-color: $bgMainColor;
        max-width: 100% !important;

        /*.v-text-field__details{*/
        /*    !*display: none;*!*/
        /*}*/
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }
    }
</style>
